module.exports = "<div class=\"rule-list\">\r\n  <div app-type=\"section\" id=\"section\" [active]=\"true\"></div>\r\n</div>"